<h3 class="wf-peppol-detail-raw-xml__heading wf-text-sm-medium">
  {{ 'PEPPOL.Detail.RawXmlSection' | translate }}
</h3>

<div class="wf-peppol-detail-raw-xml__content">
  @if (decodedContent(); as xml) {
    <pre class="wf-peppol-detail-raw-xml__xml">{{ xml }}</pre>
  } @else {
    <pre class="wf-peppol-detail-raw-xml__xml">{{ placeholder }}</pre>
    <button
      type="button"
      class="wf-peppol-detail-raw-xml__more"
      (click)="showMore.emit()"
    >
      {{ 'ShowMore' | translate }}...
    </button>
  }
</div>
